var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","disabled":_vm.disabled,"small":"","color":"pink"},on:{"click":function($event){return _vm.del()}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_c('span',[_vm._v("Delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }